import React from 'react'
import PropTypes from 'prop-types'

const OfferSearchQuantityDuration = ({ eventQuantity, duration, className }) => {
  let quantityString = ''
  let durationString = ''

  if (!!duration) {
    durationString = `${duration} Minuten`
  }
  if (!!eventQuantity) {
    if (!!duration) {
      quantityString = eventQuantity
    } else {
      if (eventQuantity === 1) {
        quantityString = '1 Termin'
      } else {
        quantityString = `${eventQuantity} Termine`
      }
    }
  }

  return (
    <p className={className}>{`${quantityString}${
      !!durationString && !!quantityString ? ' x ' : ''
    }${durationString}`}</p>
  )
}

OfferSearchQuantityDuration.propTypes = {
  eventQuantity: PropTypes.number,
  duration: PropTypes.number,
  className: PropTypes.string,
}

OfferSearchQuantityDuration.defaultProps = {
  className: '',
}

export default OfferSearchQuantityDuration
